export default __webpack_public_path__ + "static/media/footer.f2fc9dd6.png";